module.exports = __webpack_public_path__ + "img/title-dver-2-m@3x.ae53cbb2.png";